<template>
  <div id="filter-radar-grid-type">
    <div>
      <!--
        TODO: フィルタが1種類しかないのでコメントアウト中
        今後フィルタの種類が増えた際に「全て」のスイッチを表示する
      <vs-row vs-type="flex" class="mt-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="6"
        >
          <span class="aisea-text-16-400-white">全て</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="allSwitch" />
        </vs-col>
      </vs-row>

      <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY" />
      -->

      <!-- 進路予測 -->
      <!--
        TODO: 「」のスイッチを表示する際にコメント中のclassを戻す
        <vs-row vs-type="flex" class="mt-6"> -->
      <vs-row vs-type="flex">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img
            class="filter-radar-grid-img"
            src="@/assets/images/radarGrid/wake_forecast.svg"
          />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">進路予測</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="wakeForecastSwitch" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
import { RADAR_GRID_CATEGORY } from "@/config/const";
const getRadarGridCategoryIds = (() => {
  const radarGridCategoryIds = Object.values(RADAR_GRID_CATEGORY).map(
    (category) => String(category),
  );
  return () => radarGridCategoryIds;
})();
// Store
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

export default {
  name: "RadarGridType",
  mixins: [ColorMixin],
  components: {},
  data() {
    return {
      isAllSwitchOnEvent: false,
      isAllFilterOffEvent: false,
      localFilterRadarGrid: [], // Array<String> デフォルトは非表示
      allSwitch: false,
      wakeForecastSwitch: false,
    };
  },
  computed: {},
  watch: {
    localFilterRadarGrid(val) {
      this._setFilterRadarGrid(this, val);
    },
    async allSwitch(isOn) {
      if (isOn) {
        if (!this.isAllSwitchOnEvent) {
          await this.setAllFilter(true);
          this.localFilterRadarGrid = getRadarGridCategoryIds();
        } else {
          this.isAllSwitchOnEvent = false;
        }
      } else {
        this.localFilterRadarGrid = [];
        this.isAllFilterOffEvent = true;
        await this.setAllFilter(false);
        this.isAllFilterOffEvent = false;
      }
    },
    wakeForecastSwitch(isOn) {
      this.setFilterState(isOn, String(RADAR_GRID_CATEGORY.WAKE_FORECAST));
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["setFilterRadarGrid"]),
    _setFilterRadarGrid: debounce((self, val) => {
      const filterRadarGrid = cloneDeep(val);
      FireStoreService.saveFilterRadarGrid(filterRadarGrid);
      LocalDbService.saveFilterRadarGrid(filterRadarGrid);
      self.setFilterRadarGrid(filterRadarGrid);
    }, 1000),
    setFilterState(isOn, radarGridCategory) {
      if (this.isAllFilterOffEvent) return;
      if (isOn) {
        this.localFilterRadarGrid.push(radarGridCategory);
      } else {
        this.filterCategory(radarGridCategory);
      }
      if (this.localFilterRadarGrid.length === 0) {
        this.allSwitch = false;
      }
      if (
        getRadarGridCategoryIds().length === this.localFilterRadarGrid.length
      ) {
        this.allSwitch = true;
      }
    },
    filterCategory(id) {
      this.localFilterRadarGrid = this.localFilterRadarGrid.filter((v) => {
        return v !== id;
      });
    },
    async setAllFilter(val) {
      this.wakeForecastSwitch = val;
    },
    async setFilterSwitch(filterRadarGrid) {
      filterRadarGrid.forEach((type) => {
        switch (Number(type)) {
          case RADAR_GRID_CATEGORY.WAKE_FORECAST:
            this.wakeForecastSwitch = true;
            break;
        }
      });
    },
  },
  async created() {
    const filterRadarGrid = await LocalDbService.getFilterRadarGrid();
    if (filterRadarGrid.length === 0) {
      this.allSwitch = false;
      await this.setAllFilter(false);
      this.localFilterRadarGrid = filterRadarGrid;
    } else {
      await this.setFilterSwitch(filterRadarGrid);
      this.localFilterRadarGrid = filterRadarGrid;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

#filter-radar-grid-type {
  background: $aisea-blue-gray;

  .filter-radar-grid-img {
    height: 20px;
    width: 20px;
  }
}
</style>
